<ds-alert-modal [config]="modalConfig" (primaryEvent)="closeModal()"></ds-alert-modal>
